import { useState, useCallback } from 'react';
import cn from 'classnames';

import IconAvatar from 'shared/IconAvatar';

import { useClientContext, useTranslationContext } from 'hooks';

import classes from './CategoriesFilter.module.scss';

export default function CategoriesFilter(props: {
  activeFilters?: string[];
  onSubmitFilter?: (f: string[]) => void;
  onDiscardFilter?: () => void;
}) {
  const { activeFilters = [] as string[], onSubmitFilter = (f: string[]) => { }, onDiscardFilter = () => { } } = props;
  const { client, categories } = useClientContext();
  const { t, translateCustomText } = useTranslationContext();
  const [selectedCategories, setSelectedCategories] = useState(activeFilters);

  const toggleCategory = useCallback(
    (category: string) => {
      if (selectedCategories.includes(category)) {
        setSelectedCategories(currentSelection => currentSelection.filter(c => c !== category));

        return;
      }

      setSelectedCategories(currentSelection => [...currentSelection, category]);
    },
    [selectedCategories, setSelectedCategories]
  );

  const handleClick = useCallback(
    (event: MouseEvent | any, type: 'clear' | 'done') => {
      event.preventDefault();
      event.stopPropagation();

      if (type === 'clear') {
        setSelectedCategories([]);
        onDiscardFilter();

        return;
      }

      onSubmitFilter(selectedCategories);
    },
    [onDiscardFilter, onSubmitFilter, selectedCategories]
  );

  return (
    <div className={cn(classes.CategoriesFilter, 'CategoriesFilter')}>
      <h6>{client?.clientType === 'Campaign' ? t('Trending Issues') :t('Trending Categories')}</h6>

      <div className={classes.capsuleLayout}>
        {categories.map(category => (
          <button
            key={category}
            className={selectedCategories.includes(category) ? classes.active + ' activeFilter': ''}
            type="button"
            onClick={() => toggleCategory(category)}
          >
            <IconAvatar categoryIcon={category} iconClass={classes.categoryIcon} wrapperClass={classes.iconWrapper + ' iconWrapper'} />
            {translateCustomText(category, category)}
          </button>
        ))}
      </div>
      <div className={classes.buttonGroup}>
        <button type="button" className={classes.cancel + ' cancel'} onClick={e => handleClick(e, 'clear')}>
          {t('Clear')}
        </button>

        <button type="button" className={classes.primary + ' primary'} onClick={e => handleClick(e, 'done')}>
          {t('Done')}
        </button>
      </div>
    </div>
  );
}
